const isIosDevice = (): boolean =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
  (window.navigator.platform === "MacIntel" &&
    window.navigator.maxTouchPoints > 1);

const isAndroid = (): boolean => /android/i.test(window.navigator.userAgent);

export const useIsDesktopPWA = (): boolean => !isIosDevice() && !isAndroid();
